const PAGE_SIZE = process.env.REACT_APP_PAGE_SIZE || 5;

export { PAGE_SIZE };
